import type { ReactNode } from 'react';

/** Wrap every surface. Sets data-brand so tokens resolve to Quixo Marketing, and dir for RTL. */
export function BrandRoot({ children, dir = 'ltr', lang = 'en' }: { children: ReactNode; dir?: 'ltr' | 'rtl'; lang?: string }) {
  return (
    <div className="qm-root" data-brand="quixo-marketing" dir={dir} lang={lang}>
      {children}
    </div>
  );
}
